import React, { useEffect } from "react";
import Header from "../../components/home/Header";
import Footer from "../../components/home/Footer";
import ContactUsContainer from "../../components/contactUs/ContactUsContainer";

const ContactUsPage = () => {
  useEffect(() => {
    window.scroll("scroll", function () {
      window.scroll(0, 0);
    });
  }, []);
  return (
    <div>
      <Header />
      <ContactUsContainer />
      <Footer />
    </div>
  );
};

export default ContactUsPage;
